<ng-container *ngIf="isLoading">
    <fa-icon [icon]="loaderIcon" [spin]="true" aria-hidden="true" [ngClass]="className"></fa-icon>
    <span *ngIf="hasText" class="ml-2">
        <ng-content #text></ng-content>
        <span *ngIf="text != null && text.children.length == 0">
            {{ 'loading' | translate }}
        </span>
    </span>
</ng-container>